module.exports = __webpack_public_path__ + "static/media/lance-coury-photo-1.184f88a9.jpg";